var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isshow
        ? _c(
            "van-tabs",
            {
              on: { change: _vm.change },
              model: {
                value: _vm.active,
                callback: function($$v) {
                  _vm.active = $$v
                },
                expression: "active"
              }
            },
            [
              _c(
                "van-tab",
                [
                  _c(
                    "div",
                    {
                      staticClass: "title",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n                    参与活动\n                    "
                        ),
                        _vm.relaCnt && _vm.relaCnt.campaignCnt > 0
                          ? _c("div", { staticClass: "infos" }, [
                              _vm._v(_vm._s(_vm.relaCnt.campaignCnt))
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("JnActivity", {
                    ref: "JnActivity",
                    attrs: { custId: this.custId }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-tab",
                [
                  _c(
                    "div",
                    {
                      staticClass: "title",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n                    参与课程\n                    "
                        ),
                        _vm.relaCnt && _vm.relaCnt.courseCnt > 0
                          ? _c("div", { staticClass: "infos" }, [
                              _vm._v(" " + _vm._s(_vm.relaCnt.courseCnt))
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("JnCurriculum", {
                    ref: "JnCurriculum",
                    attrs: { custId: this.custId }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd68c368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd68c368","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/joinTab.vue
// module id = null
// module chunks = 